import React, { useEffect, useState } from "react";
import { Card, Descriptions, Spin, message } from "antd";
import { useParams } from "react-router-dom";
import { apiService } from "@/services/api";

export const TypeShow: React.FC = () => {
  const { id } = useParams();
  const [type, setType] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await apiService.getContentTypes();
        const t = (data as any[]).find((x: any) => String(x.id) === String(id));
        setType(t);
      } catch (e) {
        message.error("Impossible de charger le type");
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (loading) return <Spin />;
  if (!type) return null;

  return (
    <Card title={`Type de contenu #${type.id}`}>
      <Descriptions bordered column={1}>
        <Descriptions.Item label="ID">{type.id}</Descriptions.Item>
        <Descriptions.Item label="Titre">{type.title}</Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default TypeShow;
